unit View.Grade_Descricoes.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewGrade_DescricoesEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbtipo: TLabel;
    edtipo: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientGrade_DescricoesGet: TXDataWebClient;
    XDataClientGrade_DescricoesDelete: TXDataWebClient;
    Grade_DescricoesDataset: TXDataWebDataSet;
    Grade_DescricoesDatasetid: TIntegerField;
    Grade_DescricoesDatasetaliado_id: TIntegerField;
    Grade_DescricoesDatasetdata_base_id: TIntegerField;
    Grade_DescricoesDatasetnome: TStringField;
    Grade_DescricoesDatasettipo: TIntegerField;
    Grade_DescricoesDatasetcodigo_interno: TIntegerField;
    Grade_DescricoesDatasetexcluido: TBooleanField;
    Grade_DescricoesDatasetinclusao: TDateTimeField;
    Grade_DescricoesDatasetalteracao: TDateTimeField;
    Grade_DescricoesDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientGrade_DescricoesGetLoad(Response: TXDataClientResponse);
    procedure XDataClientGrade_DescricoesDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientGrade_DescricoesDeleteError(Error: TXDataClientError);
    procedure Grade_DescricoesDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewGrade_DescricoesEdit: TFViewGrade_DescricoesEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGrade_DescricoesEdit }

procedure TFViewGrade_DescricoesEdit.btSaveClick(Sender: TObject);
begin
  if Grade_DescricoesDataset.State in dsEditModes then
  begin
        Grade_DescricoesDataset.Post;
    Grade_DescricoesDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewGrade_DescricoesEdit.btDeleteClick(Sender: TObject);
begin
  if Grade_DescricoesDataset.State in dsEditModes then
    Grade_DescricoesDataset.Post;
  XDataClientGrade_DescricoesDelete.Delete(Grade_DescricoesDataset.EntitySetName,
    TJSObject(Grade_DescricoesDataset.CurrentData));
end;


class function TFViewGrade_DescricoesEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewGrade_DescricoesEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewGrade_DescricoesEdit.InsertEntity;
begin
  Grade_DescricoesDataset.Close;
  Grade_DescricoesDataset.SetJsonData('{}');
  Grade_DescricoesDataset.Open;
  Grade_DescricoesDataset.Insert;
end;

class function TFViewGrade_DescricoesEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGrade_DescricoesEdit(AForm).FInserting := AInserting;
    TFViewGrade_DescricoesEdit(AForm).FId := AId;
    TFViewGrade_DescricoesEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewGrade_DescricoesEdit(AForm).InsertEntity
    else
      TFViewGrade_DescricoesEdit(AForm).LoadEntity;
    TFViewGrade_DescricoesEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewGrade_DescricoesEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewGrade_DescricoesEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Grade_DescricoesDataset.Connection.Model.DefaultSchema.FindEntityType(
      Grade_DescricoesDataset.EntitySetName
    )
  );
  XDataClientGrade_DescricoesGet.Get(Grade_DescricoesDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewGrade_DescricoesEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewGrade_DescricoesEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGrade_DescricoesEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGrade_DescricoesEdit.XDataClientGrade_DescricoesGetLoad(Response: TXDataClientResponse);
begin
  Grade_DescricoesDataset.Close;
  Grade_DescricoesDataset.SetJsonData(Response.Result);
  Grade_DescricoesDataset.Open;
  
  Grade_DescricoesDataset.Edit;  
end;

procedure TFViewGrade_DescricoesEdit.XDataClientGrade_DescricoesDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewGrade_DescricoesEdit.XDataClientGrade_DescricoesDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewGrade_DescricoesEdit.Grade_DescricoesDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewGrade_DescricoesEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewGrade_DescricoesEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.grade_descricoes.form.message');
  lbMessage := TLabel.Create('view.grade_descricoes.form.message.label');
  btCloseMessage := TButton.Create('view.grade_descricoes.form.message.button');
  btCancel := TButton.Create('view.grade_descricoes.form.btBack');
  btSave := TButton.Create('view.grade_descricoes.form.btSave');
  btDelete := TButton.Create('view.grade_descricoes.form.btDelete');
  lbid := TLabel.Create('view.grade_descricoes.form.lbid');
  edid := TDBEdit.Create('view.grade_descricoes.form.edid');
  lbaliado_id := TLabel.Create('view.grade_descricoes.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.grade_descricoes.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.grade_descricoes.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.grade_descricoes.form.eddata_base_id');
  lbnome := TLabel.Create('view.grade_descricoes.form.lbnome');
  ednome := TDBEdit.Create('view.grade_descricoes.form.ednome');
  lbtipo := TLabel.Create('view.grade_descricoes.form.lbtipo');
  edtipo := TDBEdit.Create('view.grade_descricoes.form.edtipo');
  lbcodigo_interno := TLabel.Create('view.grade_descricoes.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.grade_descricoes.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.grade_descricoes.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.grade_descricoes.form.edexcluido');
  lbinclusao := TLabel.Create('view.grade_descricoes.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.grade_descricoes.form.edinclusao');
  lbalteracao := TLabel.Create('view.grade_descricoes.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.grade_descricoes.form.edalteracao');
  lbexclusao := TLabel.Create('view.grade_descricoes.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.grade_descricoes.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Grade_DescricoesDataset := TXDataWebDataSet.Create(Self);
  Grade_DescricoesDatasetid := TIntegerField.Create(Self);
  Grade_DescricoesDatasetaliado_id := TIntegerField.Create(Self);
  Grade_DescricoesDatasetdata_base_id := TIntegerField.Create(Self);
  Grade_DescricoesDatasetnome := TStringField.Create(Self);
  Grade_DescricoesDatasettipo := TIntegerField.Create(Self);
  Grade_DescricoesDatasetcodigo_interno := TIntegerField.Create(Self);
  Grade_DescricoesDatasetexcluido := TBooleanField.Create(Self);
  Grade_DescricoesDatasetinclusao := TDateTimeField.Create(Self);
  Grade_DescricoesDatasetalteracao := TDateTimeField.Create(Self);
  Grade_DescricoesDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientGrade_DescricoesGet := TXDataWebClient.Create(Self);
  XDataClientGrade_DescricoesDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbtipo.BeforeLoadDFMValues;
  edtipo.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Grade_DescricoesDataset.BeforeLoadDFMValues;
  Grade_DescricoesDatasetid.BeforeLoadDFMValues;
  Grade_DescricoesDatasetaliado_id.BeforeLoadDFMValues;
  Grade_DescricoesDatasetdata_base_id.BeforeLoadDFMValues;
  Grade_DescricoesDatasetnome.BeforeLoadDFMValues;
  Grade_DescricoesDatasettipo.BeforeLoadDFMValues;
  Grade_DescricoesDatasetcodigo_interno.BeforeLoadDFMValues;
  Grade_DescricoesDatasetexcluido.BeforeLoadDFMValues;
  Grade_DescricoesDatasetinclusao.BeforeLoadDFMValues;
  Grade_DescricoesDatasetalteracao.BeforeLoadDFMValues;
  Grade_DescricoesDatasetexclusao.BeforeLoadDFMValues;
  XDataClientGrade_DescricoesGet.BeforeLoadDFMValues;
  XDataClientGrade_DescricoesDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewGrade_DescricoesEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 535;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 475;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 475;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 475;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 273;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 270;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbtipo.SetParentComponent(Self);
    lbtipo.Name := 'lbtipo';
    lbtipo.Left := 24;
    lbtipo.Top := 300;
    lbtipo.Width := 14;
    lbtipo.Height := 13;
    lbtipo.Caption := 'tipo:';
    lbtipo.Transparent := True;
    edtipo.SetParentComponent(Self);
    edtipo.Name := 'edtipo';
    edtipo.Left := 221;
    edtipo.Top := 297;
    edtipo.Width := 200;
    edtipo.Height := 21;
    edtipo.Enabled := True;
    edtipo.TabOrder := 10;
    edtipo.Text := 'edtipo';
    edtipo.DataField := 'tipo';
    edtipo.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 327;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 324;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 11;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 354;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 351;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 12;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 381;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 378;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 13;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 408;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 405;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 14;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 435;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 432;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 15;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Grade_DescricoesDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Grade_DescricoesDataset.SetParentComponent(Self);
    Grade_DescricoesDataset.Name := 'Grade_DescricoesDataset';
    Grade_DescricoesDataset.AfterApplyUpdates := Grade_DescricoesDatasetAfterApplyUpdates;
    Grade_DescricoesDataset.EntitySetName := 'Grade_Descricoes';
    Grade_DescricoesDataset.Connection := DMConnection.ApiConnection;
    Grade_DescricoesDataset.Left := 176;
    Grade_DescricoesDataset.Top := 8;
    Grade_DescricoesDatasetid.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetid.Name := 'Grade_DescricoesDatasetid';
    Grade_DescricoesDatasetid.FieldName := 'id';
    Grade_DescricoesDatasetid.Required := True;
    Grade_DescricoesDatasetaliado_id.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetaliado_id.Name := 'Grade_DescricoesDatasetaliado_id';
    Grade_DescricoesDatasetaliado_id.FieldName := 'aliado_id';
    Grade_DescricoesDatasetaliado_id.Required := True;
    Grade_DescricoesDatasetdata_base_id.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetdata_base_id.Name := 'Grade_DescricoesDatasetdata_base_id';
    Grade_DescricoesDatasetdata_base_id.FieldName := 'data_base_id';
    Grade_DescricoesDatasetdata_base_id.Required := True;
    Grade_DescricoesDatasetnome.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetnome.Name := 'Grade_DescricoesDatasetnome';
    Grade_DescricoesDatasetnome.FieldName := 'nome';
    Grade_DescricoesDatasetnome.Required := True;
    Grade_DescricoesDatasetnome.Size := 255;
    Grade_DescricoesDatasettipo.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasettipo.Name := 'Grade_DescricoesDatasettipo';
    Grade_DescricoesDatasettipo.FieldName := 'tipo';
    Grade_DescricoesDatasettipo.Required := False;
    Grade_DescricoesDatasetcodigo_interno.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetcodigo_interno.Name := 'Grade_DescricoesDatasetcodigo_interno';
    Grade_DescricoesDatasetcodigo_interno.FieldName := 'codigo_interno';
    Grade_DescricoesDatasetcodigo_interno.Required := True;
    Grade_DescricoesDatasetexcluido.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetexcluido.Name := 'Grade_DescricoesDatasetexcluido';
    Grade_DescricoesDatasetexcluido.FieldName := 'excluido';
    Grade_DescricoesDatasetexcluido.Required := False;
    Grade_DescricoesDatasetinclusao.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetinclusao.Name := 'Grade_DescricoesDatasetinclusao';
    Grade_DescricoesDatasetinclusao.FieldName := 'inclusao';
    Grade_DescricoesDatasetinclusao.Required := False;
    Grade_DescricoesDatasetalteracao.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetalteracao.Name := 'Grade_DescricoesDatasetalteracao';
    Grade_DescricoesDatasetalteracao.FieldName := 'alteracao';
    Grade_DescricoesDatasetalteracao.Required := False;
    Grade_DescricoesDatasetexclusao.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetexclusao.Name := 'Grade_DescricoesDatasetexclusao';
    Grade_DescricoesDatasetexclusao.FieldName := 'exclusao';
    Grade_DescricoesDatasetexclusao.Required := False;
    XDataClientGrade_DescricoesGet.SetParentComponent(Self);
    XDataClientGrade_DescricoesGet.Name := 'XDataClientGrade_DescricoesGet';
    XDataClientGrade_DescricoesGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGrade_DescricoesGet, Self, 'OnLoad', 'XDataClientGrade_DescricoesGetLoad');
    XDataClientGrade_DescricoesGet.Left := 64;
    XDataClientGrade_DescricoesGet.Top := 8;
    XDataClientGrade_DescricoesDelete.SetParentComponent(Self);
    XDataClientGrade_DescricoesDelete.Name := 'XDataClientGrade_DescricoesDelete';
    XDataClientGrade_DescricoesDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGrade_DescricoesDelete, Self, 'OnLoad', 'XDataClientGrade_DescricoesDeleteLoad');
    SetEvent(XDataClientGrade_DescricoesDelete, Self, 'OnError', 'XDataClientGrade_DescricoesDeleteError');
    XDataClientGrade_DescricoesDelete.Left := 64;
    XDataClientGrade_DescricoesDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbtipo.AfterLoadDFMValues;
    edtipo.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Grade_DescricoesDataset.AfterLoadDFMValues;
    Grade_DescricoesDatasetid.AfterLoadDFMValues;
    Grade_DescricoesDatasetaliado_id.AfterLoadDFMValues;
    Grade_DescricoesDatasetdata_base_id.AfterLoadDFMValues;
    Grade_DescricoesDatasetnome.AfterLoadDFMValues;
    Grade_DescricoesDatasettipo.AfterLoadDFMValues;
    Grade_DescricoesDatasetcodigo_interno.AfterLoadDFMValues;
    Grade_DescricoesDatasetexcluido.AfterLoadDFMValues;
    Grade_DescricoesDatasetinclusao.AfterLoadDFMValues;
    Grade_DescricoesDatasetalteracao.AfterLoadDFMValues;
    Grade_DescricoesDatasetexclusao.AfterLoadDFMValues;
    XDataClientGrade_DescricoesGet.AfterLoadDFMValues;
    XDataClientGrade_DescricoesDelete.AfterLoadDFMValues;
  end;
end;

end.
